export const LogoMark = ({ className = "h-10 w-10" }) => (
  <span className={`${className} inline-block shrink-0 overflow-hidden rounded-lg bg-black ring-1 ring-white/10`}>
    <img src="/icons/icon-192.png" alt="Resilience Brothers" className="h-full w-full scale-[1.4] object-cover [transform-origin:50%_42%]" />
  </span>
);
